import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Dispatch = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch } = useAPIQuery({
        key: "dispatch",
        endpoint: "/api/dispatch/",
    });

    const {
        data: disptchData,
        isLoading,
        isFetching,
    } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columns = [
        {
            accessor: "so_number",
            header: "Sales Order number",
            cell: (row) => <>{row?.sales_order?.so_number}</>,
        },
        {
            accessor: "client",
            header: "Client Name",
            cell: (row) => <>{row?.client?.client_name}</>,
        },
        {
            accessor: "product",
            header: "Product Name",
            cell: (row) => <>{row?.product?.product_name}</>,
        },
        {
            accessor: "target_date",
            header: "Target Date",
            cell: (row) => (
                <>
                    {moment(row?.sales_order?.target_date).format("DD-MM-YYYY")}
                </>
            ),
        },
        {
            accessor: "dispatch_location",
            header: "Dispatch Location",
            cell: (row) => <>{row?.sales_order?.dispatch_location}</>,
        },
        {
            accessor: "dispatch_amount",
            header: "Quantity",
        },
        {
            accessor: "dispatch_date",
            header: "Dispatch Date",
            cell: (row) => (
                <>{moment(row?.dispatch_date).format("DD-MM-YYYY")}</>
            ),
        },
        {
            accessor: "dispatch_number",
            header: "Dispatch Number",
        },
        {
            accessor: "invoice_number",
            header: "Invoice Number",
        },
    ];

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/dispatch-sales-order-update", {
            state: { editpost: row.original },
        });
    };

    // const handleDeleteRow = (row) => {
    //     console.log(row);
    //     const entry_id = row.original.id;
    //     Swal.fire({
    //         text: "Are you sure? You will not be able to recover this data!",
    //         showDenyButton: true,
    //         confirmButtonText: "Yes",
    //         denyButtonText: `No, cancel!`,
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteData({ id: entry_id });
    //         }
    //     });
    // };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Dispatched Sales Orders
                        </h3>
                    </div>
                </div>
            </div>
            <Table
                data={disptchData ? disptchData?.results.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={disptchData ? disptchData.count : 0}
                globalSearch
                isLoading={isLoading || isFetching}
                editRows={
                    privileges.includes("sales_order_dispatch_update")
                        ? true
                        : false
                }
                // deleteRows={privileges.includes("client_delete") ? true : false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                // onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default Dispatch;
